import { render, staticRenderFns } from "./recommandations1.vue?vue&type=template&id=7b3a2ab6&scoped=true&"
import script from "./recommandations1.vue?vue&type=script&lang=js&"
export * from "./recommandations1.vue?vue&type=script&lang=js&"
import style0 from "./recommandations1.vue?vue&type=style&index=0&id=7b3a2ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a2ab6",
  null
  
)

export default component.exports